// extracted by css-extract-rspack-plugin
export default {"user-blocked":"user-blocked-FObWkv","userBlocked":"user-blocked-FObWkv"};